export default __webpack_public_path__ + "4a1aa0a2976838835e8416cda8c3dcf7.png";